import { c as _taggedTemplateLiteralLoose, d as _extends } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import { createElement } from 'react';
import { bool, string } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CodeComponent = function CodeComponent(props) {
  if (props.block) {
    return createElement(Box, _extends({
      use: "pre"
    }, props), createElement("code", {
      className: props.codeClassName
    }, props.children));
  }

  var className = props.codeClassName ? (props.className + " " + props.codeClassName).trim() : ("" + props.className).trim();
  return createElement(Box, _extends({
    use: "code"
  }, props, {
    className: className
  }));
};

var Code = styled(Box)(_templateObject(), theme("Code")); // @ts-ignore

Code.propTypes = {
  block: bool,
  codeClassName: string
};
Code.defaultProps = {
  use: CodeComponent,
  opaque: true,
  palette: "background",
  tone: -2
};
var Code$1 = use(Code);

export default Code$1;
